export enum ImageCompressionType {
  ORIGINAL,
  COMPRESSED,
  THUMBNAILS,
}
